module.exports = __webpack_public_path__ + "static/03-06160ffc68e15b9d427112580d291ccb.jpg";